<template>
  <div>
    <b-row>
      <!----- SideBar All Design List ---->
      <div class="sampleside">
        <sidebarAllDesignsComponent></sidebarAllDesignsComponent>
      </div>

      <!----- SideBar All Design List End ---->

      <div class="design-container-details__main">
        <div class="brand-card brandcard">
          <div class="col-md-12" style="margin-top:10px;margin-bottom:10px;"  v-if="user_type != 'Fit_Technician' && user_type!= 'PO Executive'">
            <div class="col-md-12">
              Design Title:<strong>
                &nbsp;{{ style_details.design_title }}</strong
              >
            </div>
            <div class="col-md-12">
              Style Name : &nbsp;{{ style_details.style_name }} >>
              {{ style_details.sub_cattitle }}
            </div>
            <div class="col-md-12">
              Created Date : {{ style_details.created_date }}
            </div>
            <div class="col-md-12">
              Buyer Name : {{ style_details.sendqname }}
            </div>
          </div>

          <!-- Code For Tab -->
          <navbarMenu :pocode="poStatuscode"></navbarMenu>
          <br />

          <!-- Code For Tab Ends -->
          <!-- <div class="col-md-12"> -->

          <!-- <div class="col-md-12"> -->
          <!-- <b-card  style="padding-top:10px;"> -->

          <div class="col-md-12">
            <label style="float: left;"><b>Proto sample</b></label>
            <b-button
              type="button"
              style="float: right;"
              variant="primary"
              size="md"
              v-b-modal.RequestProtoSamplemodel
              v-if="
                selected_status_code_number <= 20 && style_details.operational_status == 'Quoteapproved' &&
                user_type!='Fit_Technician' && ((style_details.assigned_to != null && user_type == 'Junior_Buyer') || (style_details.assigned_to == null && user_type == 'Buyer')  || (style_details.assigned_to == null && user_type == 'Brand_Manager'))
              "
              >Request Proto Sample</b-button
            >
          </div>
          <br />
          <!-- <b-col class="col-md-12">  -->

          <div class="col-md-12" style="padding-right: 20px;padding-left: 8px;">
            <b-table
              class="mt-4"
              show-empty
              stacked="md"
              :items="items2"
              :fields="fields1"
              :bordered="bordered"
            >
              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
              <template slot="address" slot-scope="row"
                ><div
                  style="    word-break: break-word;
    width: 300px !important; "
                >
                  {{ row.item.address }}
                </div></template
              >
              <template slot="action" slot-scope="row">
                <b-col class="md-12 pull-right text-right">
                  <b-dropdown
                    variant="link"
                    toggle-class="text-decoration-none"
                    no-caret
                    v-if="selected_operational_status != 'Approved'"
                  >
                    <template v-slot:button-content>
                      <button
                        @click="getrowdata(row.item)"
                        style="border: none;"
                      >
                        <span
                          class="cui-options icons font-1xl d-block"
                          style="font-size: 20px;"
                        ></span>
                      </button>
                    </template>
                    <b-dropdown-item
                      target="_blank"
                      v-if="
                        row.item.sample_status == 'Dispatched' &&
                          (user_type == 'Brand_Manager' ||
                            user_type == 'Fit_Technician')
                      "
                    >
                      <button v-b-modal.modal-lg-upload-file>
                        <i
                          class="fa fa-upload"
                          variant="primary"
                          aria-hidden="true"
                          style="color: green; margin-left: 5px; background-color: none"
                        ></i
                        >Upload File
                      </button>
                    </b-dropdown-item>
                    <b-dropdown-item
                      target="_blank" 
                      :href="'https://fc-plm.s3.ap-south-1.amazonaws.com/'+uploadedsamplefile"
                      v-if="row.item.sample_file != null"
                    >
                      <button>
                        <i
                          class="fa fa-download"
                          variant="primary"
                          aria-hidden="true"
                          style="color: green; margin-left: 5px;"
                        ></i
                        >Download File
                      </button>
                      <!-- {{style_details.assigned_to}} -->
                    </b-dropdown-item>
                    <!-- && row.item.sample_status!='Rejected' -->
                    <!-- <b-dropdown-item 
                            target="_blank" v-if="(row.item.sample_file===null && row.item.sample_status=='Dispatched') && (user_type!='Brand_Designer' && user_type!=='Fit_Technician')">
                            <button  @click="trcfilecheck(row.item.sample_file);"><i class="fa fa-address-card-o" variant="primary" aria-hidden="true" style="color: green; margin-left: 5px;" ></i>Update Sample Status</button>
                          </b-dropdown-item> -->
                    
                    <!--v-if="row.item.sample_status=='Dispatched'"  -->
                    <b-dropdown-item
                      target="_blank"
                      v-if="
                        row.item.tracking_id != null ||
                          row.item.mode_of_transport != null
                      "
                    >
                      <button @click="opendispatchedmodel(row.item)">
                        <i
                          class="fa fa-address-card-o"
                          variant="primary"
                          aria-hidden="true"
                          style="color: green; margin-left: 5px;"
                        ></i
                        >Dispatched Details
                      </button>
                    </b-dropdown-item>
                    <b-dropdown-item
                      target="_blank"
                      v-if="
                        (row.item.sample_file !== null &&
                          row.item.sample_status == 'Dispatched' &&
                          user_type != 'Brand_Designer' &&
                            user_type !== 'Fit_Technician') ||
                          selected_reject_status == 'rerequest'
                      "
                    >
                      <button v-b-modal.modal-lg v-if="((style_details.assigned_to != null && user_type == 'Junior_Buyer') || (style_details.assigned_to == null && user_type == 'Buyer') || (style_details.assigned_to == null && user_type == 'Brand_Manager'))">
                        <i 
                          class="fa fa-address-card-o"
                          variant="primary"
                          aria-hidden="true"
                          style="color: green; margin-left: 5px;"
                        ></i
                        >Update Sample Status
                      </button>
                    </b-dropdown-item>
                  </b-dropdown>
                </b-col>
              </template>
              <template slot="vendor_sample_image" slot-scope="row">
                <img
                  v-if="row.item.vendor_sample_image !== null"
                  :src="row.item.vendor_sample_image"
                  style="width:80px;height:80px;"
                />
                <p v-if="row.item.vendor_sample_image === null">NA</p>
              </template>
            </b-table>
          </div>
          <!-- </div></div> -->
          <!-- </b-col> -->

          <!-- <b-col class="col-md-12" > -->
          <!-- <div class="col-md-12"><div class="col-md-12"> -->
          <div class="col-md-12">
            <label style="float: left;"><b>PP sample</b></label>
          </div>
          <!--  -->
          <!-- <b-button type="button" style="float:right; " variant="primary" size="md" v-b-modal.RequestPPSamplemodel disable v-if="(selected_status_code_number>=31 && (selected_status_code_number!=32 || selected_status_code_number!=33 )) && (selected_status_code_number<=37) && user_type!='Brand_Designer'">Request PP Sample</b-button> -->
          <!-- </b-col> -->
          <br />
          <!-- <b-col class="col-md-12"> -->
          <div class="col-md-12" style="padding-right: 20px;padding-left: 8px;">
            <b-table
              class="mt-4"
              show-empty
              stacked="md"
              :items="items1"
              :fields="fields2"
              :bordered="bordered"
            >
              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
              <template slot="action" slot-scope="row">
                <b-col class="md-12 pull-right text-right">
                  <b-dropdown
                    variant="link"
                    toggle-class="text-decoration-none"
                    no-caret
                    v-if="selected_operational_status != 'Approved'"
                  >
                    <template v-slot:button-content>
                      <button
                        @click="getrowdata(row.item)"
                        style="border: none;"
                      >
                        <span
                          class="cui-options icons font-1xl d-block"
                          style="font-size: 20px;"
                        ></span>
                      </button>
                    </template>
                    <b-dropdown-item
                      target="_blank"
                      v-if="
                        user_type != 'Brand_Designer' &&
                          row.item.sample_status == 'Dispatched'
                      "
                    >
                      <button v-b-modal.modal-lg-upload-file>
                        <i
                          class="fa fa-upload"
                          variant="primary"
                          aria-hidden="true"
                          style="color: green; margin-left: 5px; background-color: none"
                        ></i
                        >Upload File
                      </button>
                    </b-dropdown-item>
                    <b-dropdown-item
                      target="_blank"
                      :href="uploadedppfile"
                      v-if="
                        row.item.sample_file != null &&
                          user_type != 'Brand_Designer'
                      "
                    >
                      <button>
                        <i
                          class="fa fa-download"
                          variant="primary"
                          aria-hidden="true"
                          style="color: green; margin-left: 5px;"
                        ></i
                        >Download File
                      </button>
                    </b-dropdown-item>
                    <!-- && row.item.sample_status!='Rejected' -->
                    <b-dropdown-item
                      target="_blank"
                      v-if="
                        row.item.sample_file === null &&
                          (row.item.sample_status == 'Requested' ||
                            row.item.sample_status == 'Dispatched') &&
                          user_type != 'Brand_Designer'
                      "
                    >
                      <button @click="trcfilecheck(row.item.sample_file)" v-if="((style_details.assigned_to == null || style_details.assigned_to == '') && user_type == 'Buyer') || ((style_details.assigned_to != null || style_details.assigned_to != '') && user_type == 'Junior_Buyer')">
                        <i
                          class="fa fa-address-card-o"
                          variant="primary"
                          aria-hidden="true"
                          style="color: green; margin-left: 5px;"
                        ></i
                        >Update Sample Status
                      </button>
                    </b-dropdown-item>
                    <b-dropdown-item
                      target="_blank"
                      v-if="
                        row.item.sample_file !== null &&
                          (row.item.sample_status == 'Requested' ||
                            row.item.sample_status == 'Dispatched') &&
                          user_type != 'Brand_Designer'
                      "
                    >
                      <button v-b-modal.modal-lg  v-if="((style_details.assigned_to == null || style_details.assigned_to == '') && user_type == 'Buyer') || ((style_details.assigned_to != null || style_details.assigned_to != '') && user_type == 'Junior_Buyer')">
                        <i
                          class="fa fa-address-card-o"
                          variant="primary"
                          aria-hidden="true"
                          style="color: green; margin-left: 5px;"
                        ></i
                        >Update Sample Status
                      </button>
                    </b-dropdown-item>

                    <b-dropdown-item
                      target="_blank"
                      v-if="
                        row.item.mode_of_transport != null ||
                          row.item.tracking_id != null
                      "
                    >
                      <button @click="opendispatchedmodel(row.item)">
                        <i
                          class="fa fa-address-card-o"
                          variant="primary"
                          aria-hidden="true"
                          style="color: green; margin-left: 5px;"
                        ></i
                        >Dispatched Details
                      </button>
                    </b-dropdown-item>
                  </b-dropdown>
                </b-col>
              </template>
            </b-table>
          </div>
          <!-- </div> -->
          <!-- </div> -->
          <!-- </div>   -->
          <!-- </div> -->
          <!-- Request Proto Sample -->
          <b-modal
            id="RequestProtoSamplemodel"
            size="lg"
            title="Request Proto Sample"
            v-model="RequestProtoSamplemodel"
            @ok="RequestProtoSamplemodel = false"
          >
            <form>
              <div>
                <div class="col-md-12">
                  <b-form-group>
                    <b-col md="2" class="pull-left samplecol2">
                      <label for="name"><b>Type/Size</b></label>
                    </b-col>
                    <b-col md="1" class="pull-left samplecolon"><b>:</b></b-col>

                    <b-col md="4" class="pull-left samplecol4">
                      <!-- <input
                        v-model="protosize"
                        class="form-control"
                        type="text"
                      /> -->
                      <ejs-multiselect 
                    id="sizemultiselect"
                    placeholder="Select Size Set"
                    v-model="protosize"
                    :dataSource="typeSizes"
                    :fields="agentfields_size"
                    :showSelectAll="showSelectAll"
                    selectAllText="Select All"
                    unSelectAllText="Unselect All"
                    :class="{'input': true, 'is-invalid': protosize.length === 0 }" 
                    >  
                    </ejs-multiselect>  
                    </b-col>
                    <!-- <b-col md="4" ></b-col> -->
                  </b-form-group>

                  <b-form-group>
                    <b-col md="2" class="pull-left samplecol2">
                      <label for="name"><b>Address</b></label>
                    </b-col>
                    <b-col md="1" class="pull-left samplecolon"><b>:</b></b-col>

                    <b-col md="4 samplecol4" class="pull-left">
                      <b-form-textarea
                        v-model="protoaddress"
                        class="form-control"
                        type="text"
                        rows="3"
                        max-rows="3"
                        style="word-wrap: break-word; column-width: fixed; "
                        readonly
                        disabled
                      />
                    </b-col>
                    <!-- <b-col md="4" ></b-col> -->
                  </b-form-group>

                  <b-form-group>
                    <b-col md="2" class="pull-left samplecol2">
                      <label for="name"><b>Due Date</b></label>
                    </b-col>
                    <b-col md="1" class="pull-left samplecolon"><b>:</b></b-col>

                    <b-col md="4" class="pull-left samplecol4">
                      <datepicker
                        :bootstrap-styling="true"
                        pickerPosition="top-left"
                        slot="beforeCalendarHeader"
                        class="calender-header"
                        v-model="requestedDate"
                        id="startdate"
                        :format="DatePickerFormat"
                        :disabled-dates="disabledDatesforduedata"
                        required
                      >
                        Choose a Date
                      </datepicker>
                    </b-col>
                  </b-form-group>
                  <b-form-group>
                    <b-col md="2" class="pull-left samplecol2">
                      <label for="name"><b>Remark</b></label>
                    </b-col>
                    <b-col md="1" class="pull-left samplecolon"><b>:</b></b-col>
                    <b-col md="4" class="pull-left samplecol4">
                      <textarea
                        v-model="remark"
                        class="form-control text-left"
                        rows="2"
                        cols="40"
                      ></textarea>
                    </b-col>
                  </b-form-group>
                </div>
              </div>

              <div class="col-md-12 mb-4 text-center">
                <button
                  type="button"
                  @click="RequestProtoSamplefunction()"
                  class="btn btn-success submit_btn invoice-save-bottom"
                  style="float: right;"
                >
                  <i class="fa fa-save"></i>
                  Request Proto Sample
                </button>
              </div>
            </form>
          </b-modal>
          <!-- Request Proto Model ends -->

          <!-- Request PP Sample -->
          <b-modal
            id="RequestPPSamplemodel"
            size="lg"
            title="Request PP Sample"
            v-model="RequestPPSamplemodel"
            @ok="RequestPPSamplemodel = false"
          >
            <form>
              <div style="height: 150px;">
                <div class="col-md-12">
                  <b-form-group>
                    <b-col md="2" class="pull-left">
                      <label for="name"><b>Type/Size</b></label>
                    </b-col>
                    <b-col md="1" class="pull-left"><b>:</b></b-col>

                    <b-col md="4" class="pull-left">
                      <input
                        v-model="protosize"
                        class="form-control"
                        type="text"
                      />
                    </b-col>
                    <!-- <b-col md="4" ></b-col> -->
                  </b-form-group>

                  <b-form-group>
                    <b-col md="2" class="pull-left">
                      <label for="name"><b>Address</b></label>
                    </b-col>
                    <b-col md="1" class="pull-left"><b>:</b></b-col>

                    <b-col md="4" class="pull-left">
                      <b-form-textarea
                        v-model="protoaddress"
                        class="form-control"
                        type="text"
                        rows="8"
                        max-rows="8"
                        style="word-wrap: break-word; column-width: fixed; "
                      />
                    </b-col>
                    <!-- <b-col md="4" ></b-col> -->
                  </b-form-group>

                  <b-form-group>
                    <b-col md="2" class="pull-left">
                      <label for="name"><b>Due Date</b></label>
                    </b-col>
                    <b-col md="1" class="pull-left"><b>:</b></b-col>

                    <b-col md="4" class="pull-left ">
                      <datepicker
                        :bootstrap-styling="true"
                        pickerPosition="top-left"
                        slot="beforeCalendarHeader"
                        class="calender-header"
                        v-model="requestedDate"
                        id="startdate"
                        :format="DatePickerFormat"
                        :disabledDates="disabledDates"
                        required
                      >
                        Choose a Date
                      </datepicker>
                    </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="2" class="pull-left samplecol2">
                      <label for="name"><b>Remark</b></label>
                    </b-col>
                    <b-col md="1" class="pull-left samplecolon"><b>:</b></b-col>
                    <b-col md="4" class="pull-left samplecol4">
                      <textarea
                        v-model="remark"
                        class="form-control text-left"
                        rows="2"
                        cols="40"
                      ></textarea>
                    </b-col>
                  </b-form-group>
                </div>
              </div>
              <div class="col-md-12 mb-4 text-center">
                <button
                  type="button"
                  @click="RequestPPSamplefunction()"
                  class="btn btn-success submit_btn invoice-save-bottom"
                  style="float: right;"
                >
                  <i class="fa fa-save"></i>
                  Request PP Sample
                </button>
              </div>
            </form>
          </b-modal>
          <!-- Request PP Model ends -->

          <!-- Code For Upload file Model -->
          <b-modal
            id="modal-lg-upload-file"
            size="md"
            title="Upload File"
            v-model="uploadfilemodel"
            @ok="uploadfilemodel = false"
          >
            <b-row>
              <b-col lg="12" class="col-md-12">
                <b-form
                  name="addSegmentForm"
                  @submit.prevent="validateForm4('form-5')"
                  data-vv-scope="form-5"
                >
                  <b-row class="col-md-12">
                    <div class="col-md-4">
                      <b-form-group label="Sample Received Date">
                      </b-form-group>
                    </div>
                    <div class="col-md-7 ml-4">
                      <datepicker
                        :bootstrap-styling="true"
                        style="margin-left:4px; margin-right:-10px;"
                        label="Sample Received Date"
                        slot="beforeCalendarHeader"
                        class=""
                        v-model="sample_received_date"
                        id="sample_received_date"
                        name="sample_received_date"
                        :format="DatePickerFormat"
                        :disabledDates="disabledDates"
                        required
                      >
                      </datepicker>
                    </div>
                  </b-row>

                  <b-row class="col-md-12">
                    <div class="col-md-12">
                      <!-- <b-form-group
                  label="Sample Received Date"
                  :label-cols="5" >
                  <b-form-input type="date" class="form-control" v-model="sample_received_date" id="sample_received_date" name="sample_received_date" required></b-form-input>    
                  <datepicker :bootstrap-styling="true" 
                                      pickerPosition= "top-left"
                                         slot="beforeCalendarHeader" class="calender-header" v-model="requestedDate" id="startdate" :format="DatePickerFormat" required>
                                        Choose a Date
                                        
                                        </datepicker>
                
                </b-form-group> -->
                    </div>

                    <div class="col-md-12">
                      <b-form-group
                        label="No. Of Sample  Received"
                        :label-cols="5"
                      >
                        <b-form-input
                          type="number"
                          class="form-control"
                          v-model="no_of_pcs_received"
                          id="no_of_pcs_received"
                          name="no_of_pcs_received"
                          required
                        ></b-form-input>
                        <small class="text-danger"
                          >This field accepts only numbers</small
                        >
                      </b-form-group>
                    </div>
                    <div class="col-md-12">
                      <b-form-group label="Comment" :label-cols="5">
                        <textarea
                          type="text"
                          class="form-control"
                          v-model="comments"
                          id="comments"
                          name="comments"
                          required
                        ></textarea>
                      </b-form-group>
                    </div>

                    <div class="col-md-12">
                      <b-form-group label="Upload File" :label-cols="5">
                        <input
                          type="file"
                          @change="selectFile($event)"
                          id="file-input"
                          required
                      /></b-form-group>
                    </div>
                  </b-row>
                  <!-- Code For Progress Bar -->
                  <div
                    class="progress"
                    id="progress_bar"
                    style="display:none; margin-top: 5px; margin-bottom: 5px; width: 100%; height: 30px;font-size: 18px; font-weight: bold;"
                  >
                    <div
                      class="progress-bar progress-bar-info progress-bar-striped"
                      role="progressbar"
                      :aria-valuenow="progress"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      :style="{
                        height: '30px',
                        text: '20px',
                        align: 'center',
                        width: progress + '%',
                      }"
                    >
                      {{ progress }}%
                    </div>
                  </div>
                  <!-- Code For Progress Bar Ends -->
                  <div
                    slot="footer"
                    class="col-md-12"
                    style="margin-top:20px;text-align:right"
                  >
                    <b-button type="submit" variant="primary">Submit</b-button>
                    <b-button
                      variant="danger"
                      @click="canceluploadfilemodel()"
                      class="ml-1"
                      >cancel</b-button
                    >
                  </div>
                </b-form>
              </b-col>
            </b-row>
          </b-modal>
          <!-- Code For Upload File Ends -->

          <!-- Code For Sample Details Model -->
          <b-modal
            id="modal-lg"
            size="md"
            title="Design Details"
            v-model="showsampledetails"
            @ok="showsampledetails = false"
          >
            <b-row>
              <b-col sm="12" class="col-md-12">
                <b-form
                  name="updatesamplestatus"
                  @submit.prevent="updatesamplestatus(comment, status)"
                >
                  <b-row class="col-md-12">
                    <div class="col-md-12">
                      <b-form-group
                        label="Comment"
                        :label-cols="3"
                        class="samplecomment"
                      >
                        <b-form-textarea
                          rows="3"
                          max-rows="6"
                          class="sampletext"
                          v-model="comment"
                          type="text"
                          name="comment"
                          placeholder="Enter Comment Here..."
                        >
                        </b-form-textarea
                        ><br />
                        <b-input-group class="mb-9">
                          <label class="radio-inline"
                            ><input
                              type="radio"
                              name="optradio"
                              value="Approved"
                              v-model="status"
                              checked
                              @click="rejectmodel(0)"
                            />&nbsp;Approved</label
                          >&nbsp;&nbsp;
                          <label class="radio-inline"
                            ><input
                              type="radio"
                              name="optradio"
                              value="Reject"
                              v-model="status"
                              @click="rejectmodel(1)"
                              id="reject"
                            />&nbsp;Reject</label
                          >&nbsp;&nbsp;
                        </b-input-group>
                        <div style="display: none;" id="displayblock">
                          <b-input-group class="mb-9">
                            <label class="radio-inline"
                              ><input
                                type="radio"
                                name="rejectoptradio"
                                value="rerequest"
                                v-model="status"
                              />&nbsp;Re-Request</label
                            >&nbsp;&nbsp;
                            <label class="radio-inline"
                              ><input
                                type="radio"
                                name="rejectoptradio"
                                value="backtoquotation"
                                v-model="status"
                                v-if="sample_status != 'Rejected'"
                              />&nbsp;Back To Quotation</label
                            >&nbsp;&nbsp;
                          </b-input-group>
                        </div>
                      </b-form-group>
                      <div slot="footer" class="text-right">
                        <b-button
                          type="submit"
                          size="sm"
                          class="mr-4"
                          variant="primary"
                        >
                          Update Status</b-button
                        >
                        <b-button
                          size="sm"
                          variant="danger"
                          @click="commentcancel()"
                          >cancel</b-button
                        >
                      </div>
                    </div>
                  </b-row>

                  <!-- </div> -->

                  <div
                    slot="footer"
                    class="col-md-12"
                    style="margin-top:20px;text-align:right"
                  ></div>
                </b-form>
              </b-col>
            </b-row>
          </b-modal>
          <!-- Code For Sample Details Ends -->

          <!-- Code For Proto Dispatched Details Model -->
          <b-modal
            id="modal-lg_disptached"
            size="xl"
            title="Dispatched Details"
            v-model="showdispatcheddetails"
            @ok="showdispatcheddetails = false"
          >
            <b-row>
              <b-col sm="12" class="col-md-12">
                <b-form>
                  <b-col md="12" class="sampletable">
                    <table class="table table-responsive">
                      <thead class="theader samplehead">
                        <th>Type/Size</th>
                        <th>Shipping Company Name</th>
                        <th>Mode of Transport</th>
                        <th>Tracking ID</th>
                        <th>Due Date</th>
                        <th>Address</th>
                        <th>Sample Received Date</th>
                        <th>No. of Sample Received</th>
                        <th>Comment</th>
                      </thead>
                      <tbody>
                        <tr class="table table-hover samplebody">
                          <td>{{ selected_requested_size }}</td>
                          <td>{{ selected_shipping_company_name }}</td>
                          <td>{{ selected_mode_of_transport }}</td>
                          <td>{{ selected_tracking_id }}</td>
                          <td>{{ selected_due_date }}</td>
                          <td>{{ selected_address }}</td>
                          <td>{{ selected_sample_received_date }}</td>
                          <td>{{ selected_no_of_pcs_received }}</td>
                          <td>{{ selected_comment }}</td>
                        </tr>
                      </tbody>
                    </table>

                    <div slot="footer" class="text-right">
                      <b-button
                        size="sm"
                        variant="danger"
                        @click="dispatchedcancel()"
                        >cancel</b-button
                      >
                    </div>
                  </b-col>

                  <div
                    slot="footer"
                    class="col-md-12"
                    style="margin-top:20px;text-align:right"
                  ></div>
                </b-form>
              </b-col>
            </b-row>
          </b-modal>
        </div>
      </div>
    </b-row>
  </div>

  <!-- </div> -->
</template>

<script>
import CONSTANTS from "@/utils/constants";
import auth from "@/utils/auth";
import Vue from "vue";
import Router from "vue-router";
import Datepicker from "vuejs-datepicker";
//import {ImageMagnifier} from 'vue-image-magnifier'
import ImageMagnifier from "vue-image-magnifier";
Vue.use(ImageMagnifier);
import sidebarAllDesignsComponent from "./_sidebarAllDesignsComponent.vue";
import navbarMenu from "./_navbarMenu.vue";

const axios = require("axios");
export default {
  name: "Tabs",
  components: {
    sidebarAllDesignsComponent,
    navbarMenu,
    Datepicker,
  },

  data() {
    return {
      style_details: [],
      design_title: "",
      isBusy: false,
      customer: {},
      sample_received_date: "",
      no_of_pcs_received: "",
      comments: "",

      disabledDates: {
        to: new Date(Date.now() - 8640000),
    
      },

      disabledDatesforduedata:{
       to: new Date(Date.now() - 8640000),
       from: new Date(Date.now() + 1728000000) 

      },

      outlined: true,
      bordered: true,
      items1: [],
      items2: [],
      dispatched_items: [],
      uplodeditems: [],
      items: [],
      dlvstatus: [],
      img1: [],
      protoaddress:
        "FirstCry 4Th floor, B wing, Trade star J.B.Nagar Andheri East Mumbai - 4000059.",
      protosize: "",
      remark: "",
      ppsize: "",
      ppaddress: "",
      RequestProtoSamplemodel: false,
      RequestPPSamplemodel: false,
      showppdispatcheddetails: false,
      imgpath: [],
      urlImg: [],
      customlogdata: [],
      smslogdata: [],
      selectedDate: new Date(),
      selectedppDate: new Date(),
      // , tdClass: 't_cell'
      fields1: [
        { key: "requested_size", label: "Type/Size" },
        { key: "due_date", label: "Due Date" },
        { key: "address", label: "Address", tdClass: "proto_addr" },
        { key: "vendor_sample_image", label: "Sample Image" },
        { key: "sample_status", label: "Status" },
        { key: "action", label: "Action" },
      ],
      fields2: [
        { key: "requested_size", label: "Type/Size" },
        { key: "due_date", label: "Due Date" },
        { key: "address", label: "Address" },
        { key: "sample_status", label: "Status" },
        { key: "action", label: "Action" },
      ],
      fields_temp: [
        { key: "requested_size", label: "Type/Size" },
        { key: "due_date", label: "Due Date" },
        { key: "address", label: "Address" },
        { key: "sample_status", label: "Status" },
        { key: "action", label: "Action" },
      ],
      temp_item: [
        { key: "requested_size", label: "Type/Size" },
        { key: "due_date", label: "Due Date" },
        { key: "address", label: "Address" },
        { key: "sample_status", label: "Status" },
        { key: "action", label: "Action" },
      ],
      fields2: [
        { key: "requested_size", label: "Type/Size" },
        { key: "due_date", label: "Due Date" },
        { key: "address", label: "Address" },
        { key: "sample_status", label: "Status" },
        { key: "action", label: "Action" },
      ],
      dispatched_fields: [
        { key: "requested_size", label: "Type/Size", tdClass: "t_cell" },
        {
          key: "shipping_company_name",
          label: "Shipping Company Name",
          tdClass: "t_cell",
        },
        {
          key: "mode_of_transport",
          label: "Mode of Transport",
          tdClass: "t_cell",
        },
        { key: "tracking_id", label: "Tracking ID", tdClass: "t_cell" },
        { key: "due_date", label: "Due Date", tdClass: "t_cell" },
        { key: "address", label: "Address", tdClass: "t_cell" },
      ],
      ConsignmentMasterGetdata: [],
      isConsignmentActivityTrackingGetWeb: 0,
      isConsignmentMasterGetStatus: 0,
      isGetlogisticlogdetails: 0,
      fileupload_status: false,
      isBusy: false,
      user_type: "",
      sample_type: "",
      ppsample_type: "",
      due_date: "",
      ppdue_date: "",
      sample_status: "",
      ppsample_status: "",
      address: "",
      ppaddress: "",
      requested_size: 0,
      pprequested_size: 0,
      selected_operational_status: "",
      selected_status_code_number: 0,
      selected_status: "",
      status: "",
      comment: "",
      //protosample_status: '',
      selectedvendor_id: 0,
      ppselectedvendor_id: 0,
      ppselectedsample_id: 0,
      selectedsample_id: 0,
      showsampledetails: false,
      uploadfilemodel: false,
      showdispatcheddetails: false,
      requestedDate: "",
      DatePickerFormat: "dd/MM/yyyy",
      fileuploadedstatus: 0,
      uploadedppfile: "",
      uploadedsamplefile: "",
      selected_sample_type: "",
      selected_address: "",
      selected_sample_received_date: "",
      selected_no_of_pcs_received: "",
      selected_comment: "",
      selected_requested_size: "",
      selected_due_date: "",
      selected_mode_of_transport: "",
      selected_shipping_company_name: "",
      selected_reject_status: "",
      selected_tracking_id: "",
      progress: 0,
      poStatuscode: 0,
      file_tab_status: false,
      selectedfilename: "",
      typeSizes: [],
      designerName: "",
      style_code: "",
      style_name:"",
      vendor_name:"",
      trackingId:"",
    };
  },
  created: function() {
    this.route_id = this.$route.params.id;
    this.getdesigndetail();
    this.getrequestedsamplelist();
    this.getqutationdetails();
    var userData = localStorage.getItem("userData");
    var userInfo = JSON.parse(userData);
    this.user_type = userInfo[0].user_type;

    if (userData) {
      this.quote_tab = true;
      this.message_tab = true;
    }
  },
  mounted() {
    const typeSizesFromLocalStorage = JSON.parse(localStorage.getItem('unit'));
    console.log('unit', typeSizesFromLocalStorage);
    if (typeSizesFromLocalStorage) {
      this.typeSizes = typeSizesFromLocalStorage;
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields1
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },

  methods: {
    trcfilecheck: function(value) {
      if (value == null) {
        // alert("Please Upload TRC File...!!");
        this.$fire({
          text: " Please Upload TRC File...!!",
          type: "warning",
          timer: 30000,
        });
      }
    },
    //Function For open Dispatched model
    opendispatchedmodel(value) {
      this.selected_sample_type = value.sample_type;
      this.selected_address = value.address;
      this.selected_requested_size = value.requested_size;
      this.selected_due_date = value.due_date;
      this.selected_mode_of_transport = value.mode_of_transport;
      this.selected_shipping_company_name = value.shipping_company_name;
      this.selected_tracking_id = value.tracking_id;
      this.selected_sample_received_date = value.sample_received_date;
      this.selected_no_of_pcs_received = value.no_of_pcs_received;
      this.selected_comment = value.comment;
      this.showdispatcheddetails = !this.showdispatcheddetails;
    },
    //Function For dispatched model ends

    // Function For Quotation listing
    getqutationdetails: function() {
      document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem("userData");

      var userInfo = JSON.parse(userData);
      this.vendor_id = userInfo[0].vendor_id;

      const Obj = {
        style_id: this.$route.params.id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getqutationdetails`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.items = this.result.returnvalue;
            this.isBusy = !this.isBusy;
            this.totalRows = this.result.returnvalue.length;
          } else {
            this.items = [];
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    rejectmodel: function(value) {
      if (value == 0) {
        document.getElementById("displayblock").style.display = "none";
      } else if (value == 1) {
        document.getElementById("displayblock").style.display = "block";
      }

      //this.showsampledetails = !this.showsampledetails;
      //this.RequestProtoSamplemodel = !this.RequestProtoSamplemodel;
    },
    // rerequestmodel: function(){
    //   this.showsampledetails = !this.showsampledetails;
    //   this.RequestProtoSamplemodel = !this.RequestProtoSamplemodel;

    // },
    commentcancel: function() {
      this.showsampledetails = !this.showsampledetails;
    },
    dispatchedcancel: function() {
      this.showdispatcheddetails = !this.showdispatcheddetails;
    },
    RequestProtoSamplefunction() {
      if (this.protosize.length === 0) {
        // Show error message or handle the case when selection is not made
        console.log("Selection is required.");
        this.$fire({
              text: " Size selection is required.",
              type: "Warning",
              timer: 30000,
            });
        return;
      }
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      // var fromdate = this.formatDate(this.selectedDate);
      var fromdate =
        this.requestedDate != null ? this.formatDate(this.requestedDate) : "";
      var PROTO_Sample = "PROTO_Sample";

      const obj = {
        sample_type: PROTO_Sample,
        requested_size: this.protosize,
        due_date: `${fromdate}`,
        created_by: userInfo[0].email_id,
        address: this.protoaddress,
        style_id: this.$route.params.id,
        vendor_id: this.selectedvendor_id,
        remark: this.remark,
      };
      // return false;
      axios
        .post(`${CONSTANTS.API_URL}/saverequestedsample`, obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";

          if (response.data.returnmsg == "Successful") {
          //   alert("Proto Sample Requested Successfully.");
          //   this.$fire({
          //    text: " Proto Sample Requested Successfully.",
          //    type: "success",
          //    timer: 30000,
            //  });
          
            let brandName = JSON.parse(localStorage.getItem('selectedBrandId')).target.value.split('+');
            let obj = {
                  brand: brandName,
                  vendorArr: [this.selectedvendor_id],
              };

            // Get vendor name and email
            axios.post(`${CONSTANTS.API_URL}/getVendorNameAndEmail`, obj)
                .then(response => {
                  if (response.data.returnmsg === "Successful") {
                    const emailObj = {
                      brand_name: brandName,
                      designer_name: this.designerName,
                      style_code: this.style_code,
                      style_name: this.style_name,
                      vendor_name: this.vendor_name,
                      vendor_details: response.data.returnvalue,
                      user_id: userInfo[0].user_id,
                    }

                    console.log("emailobj--------------------------->", emailObj);

                    axios
                      .post(`${CONSTANTS.API_URL}/addEmailTriggersDesignIsApproved`, emailObj)
                      .then((response) => {
                        document.getElementById("overlay").style.display = "none";
                        if (response.data.returnmsg === "Successful") {
                          this.$fire({
                            text: "Proto Sample Requested Successfully and email has been sent for approval",
                            type: "success",
                            timer: 30000,
                          });
                        }
                        else {
                          this.$fire({
                            text: response.data.returnvalue,
                            type: "danger",
                            timer: 30000,
                          });
                        }
                      })
                  }
                  
                    else {
                        this.$fire({
                            text: response.data.returnvalue,
                            type: "warning",
                            timer: 30000,
                        });
                    }
                  
             })
            this.getrequestedsamplelist();
            
            this.RequestProtoSamplemodel = !this.RequestProtoSamplemodel;
            this.getdesigndetail();
          } else {
            if (result.body.returnmsg === "NoUserExists") {
              this.showAlert = true;
            }
          }
        });
    },
    updatesamplestatus: function(comment, value) {
      document.getElementById("overlay").style.display = "block";

      var status = value;
      var comment = comment;
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      var user_id = userInfo[0].user_id;
      if (status != "") {
        const Obj = {
          sample_status: value,
          updated_by: userInfo[0].email_id,
          style_id: this.selected_style_id,
          comments: comment,
          vendor_id: this.selectedvendor_id,
          sample_id: this.selectedsample_id,
        };

        axios
          .post(`${CONSTANTS.API_URL}/updatesamplestatus`, Obj)
          .then((response) => {
          
            this.result = response.data;
            if (this.result.returnmsg === "Successful") {
              // alert("Status Updated Successfully");
              // this.$fire({
              //   text: "Status Updated Successfully.",
              //   type: "success",
              //   timer: 30000,
              // });
            let brandName = JSON.parse(localStorage.getItem('selectedBrandId')).target.value.split('+');
            let obj = {
                  brand: brandName,
                  vendorArr: [this.selectedvendor_id],
              };

            // Get vendor name and email
            axios.post(`${CONSTANTS.API_URL}/getVendorNameAndEmail`, obj)
                .then(response => {
                  if (response.data.returnmsg === "Successful") {
                    const emailObj = {
                      brand_name: brandName,
                      designer_name: this.designerName,
                      style_code: this.style_code,
                      style_name: this.style_name,
                      vendor_name: this.vendor_name,
                      vendor_details: response.data.returnvalue,
                      trackingId:this.trackingId,
                      user_id: userInfo[0].user_id,
                    }

                    console.log("emailobj--------------------------->", emailObj);

                    axios
                      .post(`${CONSTANTS.API_URL}/addEmailTriggersDesignIsApproved`, emailObj)
                      .then((response) => {
                        document.getElementById("overlay").style.display = "none";
                        if (response.data.returnmsg === "Successful") {
                          document.getElementById("overlay").style.display = "none";
                          this.$fire({
                            text: "Sample approved and email has been sent for approval",
                            type: "success",
                            timer: 30000,
                          });
                        }
                        else {
                          this.$fire({
                            text: response.data.returnvalue,
                            type: "danger",
                            timer: 30000,
                          });
                        }
                      })
                  }
                  
                    else {
                        this.$fire({
                            text: response.data.returnvalue,
                            type: "warning",
                            timer: 30000,
                        });
                    }
                  
             })


              this.showsampledetails = !this.showsampledetails;
              this.selected_reject_status = value;
              this.getdesigndetail();
              this.getrequestedsamplelist();
              // router.reload();
              if (value == "rerequest") {
                this.showsampledetails = false;
                this.RequestProtoSamplemodel = true;
                //this.getdesigndetail();
              }
              if (value == "backtoquotation") {
                this.$router.push({ path: `/design_quotes/${this.route_id}` });
                //this.getdesigndetail();
              }
              this.getdesigndetail();
            } else {
              // alert("Please Check Status");
              this.$fire({
                text: "Please Check Status.",
                type: "warning",
                timer: 30000,
              });
            }
          })
          .catch((e) => {
            this.errors.push(e);
          });
      } else {
        document.getElementById("overlay").style.display = "none";
        this.$fire({
          text: "Please Check Status",
          type: "warning",
          timer: 120000,
        });
      }
    },

    validateForm4(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.upload();
        }
      });
    },

    selectFile(event) {
      this.selectedFiles = event.target.files[0];
      this.imgname = this.selectedFiles.name;
      console.log(this.selectedFiles);
    },
    upload: function() {
      document.getElementById("progress_bar").style.display = "block";
      document.getElementById("overlay").style.display = "block";
      this.id = this.$route.params.id;
      // console.log(this.id);
      // console.log(this.sample_received_date);
      // console.log(this.no_of_pcs_received);

      this.progress = 0;
      var fromdate = this.formatDate(this.sample_received_date);
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      let data = new FormData();
      // let file = event.target.files[0];
      // this.selectedfilename= file.name;
      data.append("file", this.selectedFiles);
      data.append("style_id", this.id);
      data.append("vendor_id", this.selectedvendor_id);
      data.append("sample_id", this.selectedsample_id);
      data.append("updated_by", userInfo[0].email_id);
      data.append("sample_received_date", fromdate);
      data.append("no_of_pcs_received", this.no_of_pcs_received);
      data.append("comments", this.comments);

      let config = {
        header: {
          "Content-Type": "multipart/form-data",
        },
      };

      if (this.selectedFiles.size >= 10174700) {
        if (
          this.selectedFiles.type === "application/zip" ||
          this.selectedFiles.type === "application/x-xz" ||
          this.selectedFiles.type === "application/x-bzip" ||
          this.selectedFiles.type === "application/x-7z-compressed" ||
          this.selectedFiles.type === "application/vnd.rar"
        ) {
          axios
            .post(`${CONSTANTS.API_URL}/uploadsamplefiles`, data, {
              header: {
                "Content-Type": "multipart/form-data",
              },
              onUploadProgress: function(progressEvent) {
                this.progress = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                );
              }.bind(this),
            })
            .then((response) => {
              this.progress = Math.round(
                (100 * response.loaded) / response.total
              );
              document.getElementById("overlay").style.display = "none";
              if (response.data.returnmsg == "Successful") {
                // alert(" File Added Successfully.");
                this.$fire({
                  text: "File Added Successfully.",
                  type: "success",
                  timer: 30000,
                });
                document.getElementById("progress_bar").style.display = "none";
                this.uploadedppfile = response.data.url;
                this.fileuploadedstatus = 1;
                this.uploadfilemodel = !this.uploadfilemodel;
                this.getrequestedsamplelist();
              } else {
                if (result.body.returnmsg === "NoUserExists") {
                  this.showAlert = true;
                }
              }
            });
        } else {
          // alert("File Size is too large please upload Zip file");
          this.$fire({
            text: "File Size is too large Please upload Zip File.",
            type: "warning",
            timer: 30000,
          });
          document.getElementById("overlay").style.display = "none";
        }
      } else {
        // Here we can write code for upload TRF file and other fields
        axios
          .post(`${CONSTANTS.API_URL}/uploadsamplefiles`, data, {
            header: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: function(progressEvent) {
              this.progress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
            }.bind(this),
          })
          .then((response) => {
            this.progress = Math.round(
              (100 * response.loaded) / response.total
            );
            document.getElementById("overlay").style.display = "none";
            if (response.data.returnmsg == "Successful") {
              // alert(" File Added Successfully.");
              this.$fire({
                text: "File Added Successfully.",
                type: "success",
                timer: 30000,
              });
              document.getElementById("progress_bar").style.display = "none";
              this.uploadedppfile = response.data.url;
              this.fileuploadedstatus = 1;
              this.uploadfilemodel = !this.uploadfilemodel;
              this.getrequestedsamplelist();
            } else {
              if (result.body.returnmsg === "NoUserExists") {
                this.showAlert = true;
              }
            }
          });
      }
    },

    canceluploadfilemodel: function() {
      // alert()
      this.uploadfilemodel = !this.uploadfilemodel;
    },

    getrowdata(value) {
      console.log("RRRRRRRRRRRRrr", value);
      this.sample_type = value.sample_type;
      this.due_date = value.due_date;
      this.sample_status = value.sample_status;
      this.address = value.address;
      this.requested_size = value.requested_size;
      this.selectedvendor_id = value.vendor_id;
      this.selectedsample_id = value.sample_id;
    },

    /*****Function For Request PP Sample ******/
    RequestPPSamplefunction() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      // var fromdate = this.formatDate(this.selectedDate);
      var fromdate =
        this.requestedDate != null ? this.formatDate(this.requestedDate) : "";
      var PP_Sample = "PP_Sample";

      const obj = {
        sample_type: PP_Sample,
        requested_size: this.protosize,
        due_date: `${fromdate}`,
        created_by: userInfo[0].email_id,
        address: this.protoaddress,
        style_id: this.$route.params.id,
        vendor_id: this.selectedvendor_id,
        remark: this.remark,
      };
      // return false;
      axios
        .post(`${CONSTANTS.API_URL}/saverequestedsample`, obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          if (response.data.returnmsg == "Successful") {
            // alert("PP Sample Requested Successfully.");
            this.$fire({
              text: "PP Sample Requested Successfully.",
              type: "success",
              timer: 30000,
            });
            this.getrequestedsamplelist();
            this.RequestPPSamplemodel = !this.RequestPPSamplemodel;
          } else {
            if (result.body.returnmsg === "NoUserExists") {
              this.showAlert = true;
            }
          }
        });
    },
    /*****Function For Request PP Sample Ends ******/

    /****** Function to design details ********/
    getdesigndetail: function() {
      this.isBusy = true;

      const Obj = {
        style_id: this.$route.params.id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getdesigndetail`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.style_details = this.result.returnvalue[0];
            this.poStatuscode = this.style_details.status_code_number;
            console.log("TTTTTTYYY", this.poStatuscode);
            this.selected_style_id = this.style_details.style_id;
            this.selectedvendor_id = this.style_details.vendor_id;
            this.selected_operational_status = this.style_details.operational_status;
            this.selected_status_code_number = this.style_details.status_code_number;
            this.totalRows = this.result.returnvalue.length;
            this.designerName = this.style_details.full_name;
            this.style_code = this.style_details.style_code;
            this.style_name = this.style_details.style_name;
            this.vendor_name = this.style_details.vendor_name;
            for (var i = 0; i <= this.totalRows; i++) {
              if (this.style_details.status_code_number >= 8) {
                this.file_tab_status = true;
              }
            }
            this.fileObj = this.result.returnvalue[1].file_name;
            for (var i = 0; i <= this.fileObj.length; i++) {
              var file_name = this.fileObj[i].category_name;
              if (file_name == "Techpack") {
                this.tp_status = true;
              }
              if (file_name == "Measurement Chart") {
                this.measurementchart_status = true;
              }
              if (file_name == "BOM") {
                this.bom_status = true;
              }
              if (
                this.tp_status == true &&
                this.measurementchart_status == true &&
                this.bom_status == true
              ) {
                this.fileupload_status = true;
              }
            }

            this.totalRows = this.result.returnvalue.length;
          } else {
            this.style_details = [];
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    getrequestedsamplelist() {
      document.getElementById("overlay").style.display = "block";
      const Obj = {
        style_id: this.$route.params.id,
        // style_id: 192
      };
      axios
        .post(`${CONSTANTS.API_URL}/getrequestedsamplelist`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.items1 = this.result.returnvalue[0].PP_Sample;

            this.items2 = this.result.returnvalue[0].PROTO_Sample;
            this.dispatched_items = this.result.returnvalue[0].dispatch_Sample;
            this.uploadedsamplefile = this.items2[0].sample_file;
            console.log("OOOOOOOOOOOOOOOOOOO", this.items2[0].sample_file);
            console.log("1111111111111111111", this.items2[0].requested_size);
            console.log("2222222222222222222", typeof(this.items2[0].requested_size));
            this.isBusy = !this.isBusy;
            this.totalRows = this.result.returnvalue.length;
            this.trackingId = this.result.returnvalue[0].PROTO_Sample[0].tracking_id;
          }

          else {
            this.items = this.result.returnvalue;
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    RequestPPSample() {
      var ppfromdate = this.formatDate(this.selectedppDate);
      const obj = {
        ppsize: this.ppsize,
        ppaddress: this.ppaddress,
        ppdudate: `${ppfromdate}`,
      };
    },
    submitprotoresponse() {
      // alert(" i m in proto submit");
    },
    submitppresponse() {
      // alert(" i m in pp submit");
    },
    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
  },

  filters: {
    datechange: function(value) {
      if (value == null) {
        return "-";
      } else {
        var d = new Date(value);
        var curr_date = (d.getDate() < 10 ? "0" : "") + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? "0" + month : "" + month;
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? "pm" : "am";
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? "0" + minutes : minutes;
        var strTime = hours + ":" + minutes + " " + ampm;
        return (
          curr_date + "-" + curr_month + "-" + curr_year + "  " + " " + strTime
        );
      }
    },
  },
};
</script>
<style>
.short-div {
  height: 55px;
}

.quote-dropdowns .dropdown--accepted {
  border-top: 1px solid var(--fill-green-dark);
}

.quote-dropdowns > .card {
  background-color: var(--fill-white);
}
.quote-dropdowns .dropdown__header.dropdown__header--accepted {
  border: 1px solid var(--fill-green-dark);
  border-top: none;
  background-color: #e8fff5;
}
.card .card__section {
  flex-grow: 1;
  box-shadow: inset 0 -1px 0 0 #e5e5e5;
  box-shadow: inset 0 -1px 0 0 var(--fill-grey-light3);
}
.quote-dropdowns .dropdown__header {
  align-items: center;
  justify-items: center;
  justify-content: center;
  cursor: pointer;
}
.quote-dropdowns .card__section {
  padding: 16px 32px;
}
.f-sz-l {
  font-size: 15px;
}
.flex-col {
  flex-direction: column;
}
.flex,
.flex-col {
  display: flex;
}
.f-w-semi-bold {
  font-weight: 600;
}
.f-sz-sm {
  font-size: 12px;
}
.f-w-semi-bold {
  font-weight: 600;
}

.card .card__section {
  flex-grow: 1;
  box-shadow: inset 0 -1px 0 0 #e5e5e5;
  box-shadow: inset 0 -1px 0 0 var(--fill-grey-light3);
}
.quote-dropdowns .card__section {
  padding: 16px 32px;
}

.input-grp {
  width: 100%;
  margin-bottom: 16px;
}
.input-grp {
  margin-bottom: 10px !important;
}

.input-grp label {
  margin-bottom: 6px;
  color: #333340;
}

input[type="number"],
input[type="password"],
input[type="tel"],
input[type="text"] {
  padding: 13px 12px;
  border-radius: 2px;
  border: 1px solid #bfbfbf;
}
.input-grp input,
.input-grp label,
.input-grp select {
  display: block;
  width: 100%;
}

.input-grp select:disabled {
  background-color: #ebebe4;
}
.input-grp select {
  background: url(/static/media/ic-arrow-drop-down.1f6abe65.svg) no-repeat;
  background-position: right 8px top 6px;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}

.quote-dropdowns .dropdown__header.dropdown__header--accepted {
  border: 1px solid var(--fill-green-dark);
  border-top: none;
  background-color: #e8fff5;
}

.main_body1 {
  width: 970px;
}
/*.card-footer{
    border-radius: 0 0 15px 15px !important;
      border-top: 0 !important;
      background-color: #F5F5F5 !important;

  }*/
.container {
  align-content: center;
}
.search {
  border-radius: 15px 0 0 15px !important;
  background-color: white !important;
  border: 0 !important;
  color: white !important;
}
.search:focus {
  box-shadow: none !important;
  outline: 0px !important;
}
/*.type_msg{
      background-color: white !important;
      border:0 !important;
      color:white !important;
      height: 60px !important;
      overflow-y: auto;
    }*/
#type_msg:focus {
  box-shadow: none !important;
  outline: 0px !important;
}
.send_btn {
  border: 1 !important;
  border-color: #20a8d8;
  background-color: #4d94ff;
  cursor: pointer;
}
.search_btn {
  border-radius: #20a8d8 !important;
  border: 0 !important;
  background-color: #20a8d8;
  cursor: pointer;
}
.contacts {
  list-style: none;
  padding: 0;
}
.contacts li {
  width: 100% !important;
  padding: 5px 10px;
  margin-bottom: 15px !important;
}
.user_img {
  height: 40px;
  width: 30px;
  border: 1.5px solid #f5f6fa;
  margin-left: 10px;
}
.user_img_msg {
  height: 30px;
  width: 30px;
  border: 1.5px solid #f5f6fa;
}
.text-span {
  background: blue;
  border-radius: 50%;
  height: 26px;
  width: 26px;
  line-height: 26px;
  display: inline-block;
  text-align: center;
  margin-right: 6px;
}
.text-span2 {
  background: gray;
  border-radius: 50%;
  height: 26px;
  width: 26px;
  line-height: 26px;
  display: inline-block;
  text-align: center;
  margin-right: 6px;
}
.brand-card {
  border-radius: 0px !important;
}

.sidebar {
  background: #17a2b8 !important;
  width: 50px !important;
}

.sidebar .sidebar-nav {
  width: 50px !important;
}
.sidebar .nav {
  width: 50px !important;
}

.main {
  margin-left: 50px !important;
}
#rec_msg {
  margin-left: 40%;
  position: absolute;
}

/*** Tabb ***/
.header-tabs__navbar {
  margin-top: auto;
  align-items: center;
  border-top: 1px solid var(--fill-grey-light2);
}
.flex {
  display: flex;
}

.header-tabs__tab {
  position: relative;
  flex: 1 1;
  height: 43px !important;
  padding: 12px 22px;
  border-bottom: 3px solid var(--fill-grey-light3);
  display: flex;
  flex-direction: row;
  cursor: pointer;
  border: 1px solid #63c2de;
  border-radius: 12px;
}

.header-tabs__tab-image {
  padding-right: 8px;
}

.header-tabs__tab-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.header-tabs__tab .sub_title {
  font-size: 12px;
  line-height: 16px;
  text-transform: capitalize;
  font-weight: 400;
  color: var(--fill-grey-medium);
}

html,
body {
  margin: 0;
}
.wrapper {
  display: flex;
  flex-direction: column;
  height: 92vh;
  width: 100%;
  background-color: white;
}

/*Added Code*/
.b-table-caption-top {
  color: black;
}
.table button {
  background: #f6f7f9 !important;
  color: white !important;
  border: none;
}
.RequestSamplemodel .modal-content {
  height: 100%;
}
/*Added Code Ends*/

/*Todays CSS*/
.nav_row_tabs {
  display: flex;
  border-top: 1px solid #d7dbdd;
  border-bottom: 1px solid #d7dbdd;
}

#activeTitle {
  font-size: 14px;
}
.datepicker-dropdown.datepicker-orient-right:after {
  right: 7px;
}
.t_cell {
  word-wrap: break-word;
  column-width: fixed;
  width: 180px !important;
}
.brandcard {
  border-radius: 0px !important;
  padding-left: 10px !important;
}
@media (max-width: 360px) {
  .brandcard {
    padding-left: 12px !important;
  }
}
@media (max-width: 450px) and (min-width: 350px) {
  .brandcard {
    padding-left: 15px !important;
  }
}

@media screen and (max-width: 500px) and (min-width: 398px) {
  .samplehead {
    font-size: 10px;
  }
  .samplebody {
    font-size: 10px;
  }
}
@media screen and (max-width: 398px) and (min-width: 370px) {
  .samplehead {
    font-size: 9px;
  }
  .samplebody {
    font-size: 9px;
  }
}
@media screen and (max-width: 370px) {
  .samplehead {
    font-size: 8px;
  }
  .samplebody {
    font-size: 7px;
  }
  .sampletable {
    padding: 0px;
    overflow: auto;
  }
  .samplecomment {
    font-size: 12px;
  }
  .sampletext {
    font-size: 12px;
    margin-left: 10px;
  }
  /*.sampledate{
    width: 10px;
  }*/
  .proto_addr {
    word-wrap: break-word;
    column-width: fixed;
    width: 250px !important;
  }
}
@media screen and (max-width: 320px) {
  .vdp-datepicker__calendar {
    width: 200px !important;
    /*height: 100px !important;*/
  }
}
@media (max-width: 1040px) {
  .sampleside {
    display: none;
  }
}
@media (max-width: 540px) {
  .samplecolon {
    width: 10px;
  }
  .samplecol2 {
    width: 100px;
  }
  .samplecol4 {
    width: 200px;
  }
}
</style>
